<div class="nav-item__sync">
  <!-- Button -->
  <div
    class="nav-item__button-container"
    [ngClass]="{ 'nav-item__button-container--modified': isSyncInProcess }"
  >
    <div
      class="nav-item__button"
      [ngClass]="{ 'nav-item__button--modified': isSyncInProcess }"
      (click)="isSyncDisabled ? popupMaintenanceMessage() : togglePopup()"
    >
      <i class="nav-item__button-icon icon feather icon-repeat feather--modified"></i>
      <div class="nav-item__timeInfo">
        <p #lastSyncMessage *ngIf="lastSync" class="nav-item__timeDetail">
          Last Sync:
          <br />
          {{ lastSync | date : "MM/dd/yyyy 'at' hh:mm a" }}
        </p>
      </div>
    </div>
  </div>

  <!-- Popup Confirmation -->
  <div
    class="nav-item__message-container"
    [class]="isHide ? 'nav-item__message-container--modified' : ''"
  >
    <div
      *ngIf="
        [CompanyType.ASC, CompanyType.QBO, CompanyType.SFY].includes(currentCompany?.companyType)
      "
      class="nav-item__message-box nav-item__message-box--modified"
    >
      <div class="nav-item__message-header">
        <i class="icon feather icon-repeat"></i>
        <p class="nav-item__message-name">
          Sync with
          {{
            isCurrentCompanyASC ? "Amazon Seller Central" : isCurrentCompanyQBFS ? "QuickBooks Online" : "Shopify"
          }}
        </p>
      </div>
      <div class="nav-item__message-body">
        <p class="nav-item__message-para">
          You have chosen to sync your data. This will pull the latest data
          {{
            isCurrentCompanyASC ? "and all the shipments with open status" : ""
          }}
          from
          <b>{{
            isCurrentCompanyASC ? "Amazon Seller Central" : isCurrentCompanyQBFS ? "QuickBooks Online" : "Shopify"
          }}</b
          >. Please note that this may take some time.
        </p>
        <p class="nav-item__message-question">
          Would you like to sync your data now?
        </p>
      </div>
      <div class="nav-item__message-button">
        <a
          href="javascript:"
          class="nav-item__message-link"
          (click)="togglePopup()"
          >Cancel</a
        >
        <a
          href="javascript:"
          class="nav-item__message-link"
          (click)="startSync()"
          >Start Sync</a
        >
      </div>
      <div class="nav-item__message-close">
        <i
          class="fa fa-times fa-times--modified"
          (click)="togglePopup()"
          aria-hidden="true"
        ></i>
      </div>
    </div>

    <div
      *ngIf="currentCompany?.companyType === CompanyType.QBFS"
      class="nav-item__message-box nav-item__message-box--modified"
    >
      <div class="nav-item__message-header">
        <i class="icon feather icon-repeat"></i>
        <p class="nav-item__message-name">Sync with QuickBooks Desktop</p>
      </div>
      <div class="nav-item__message-body">
        <p class="nav-item__message-para">
          Please initiate your data syncs from your <b>QuickBooks Web Connector</b>.
        </p>
      </div>
      <div class="nav-item__message-button">
        <a
          href="javascript:"
          class="nav-item__message-link"
          (click)="togglePopup()"
          >OK</a
        >
      </div>
      <div class="nav-item__message-close">
        <i
          class="fa fa-times fa-times--modified"
          (click)="togglePopup()"
          aria-hidden="true"
        ></i>
      </div>
    </div>
  </div>

  <!-- Spinner -->
  <div class="nav-item__sync-cover" *ngIf="isProcessing">
    <div class="nav-item__sync-cover-content">
      <p class="nav-item__sync-cover-message">
        {{ header }}
        <br />
        {{ currentCompany.companyType === 'ASC' ? "" : message }}
      </p>
      <div class="progress-bar-container mx-auto d-flex align-items-center justify-content-center flex-wrap"
        *ngIf="currentCompany.companyType === 'ASC'">
        <h6 class="text-light">
          {{ message }}
        </h6>
        <div class="progress w-100">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
            [attr.aria-valuenow]="progress" [style.width.%]="progress" aria-valuenow="progress" aria-valuemin="0"
            aria-valuemax="100" style="background-color: #008643;">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
